/* ============================================
   KREM CART INTERCEPT v2.0 — NEUTRALIZED

   This file used to globally intercept all product add-to-cart
   submits and refresh the drawer. That logic now conflicts with:
     - krem-product-engine.liquid (has its own submit handler)
     - snippets/krem-cart-sync.liquid v4.0 (patches fetch/XHR globally)

   The conflict caused:
     - Bubble counts going stale or disappearing entirely
     - Drawer opening twice, animating wrong
     - Race conditions where the bubble was hidden but never restored

   Single source of truth from now on:
     1. krem-product-engine.liquid handles the click + opens drawer instantly
     2. snippets/krem-cart-sync.liquid v4.0 patches fetch/XHR globally and
        refreshes BOTH the .krem-cart-bubble in the custom header AND the
        drawer body after every cart write.

   This file is intentionally a no-op now. The exposed window helpers
   below are stubs in case any other code calls them.
============================================ */
(function () {
  'use strict';
  // Stubs for backward compatibility — do nothing.
  window.kremAddToCart  = window.kremAddToCart  || function () {};
  window.kremOpenDrawer = window.kremOpenDrawer || function () {
    var d = document.querySelector('cart-drawer');
    if (d && typeof d.open === 'function') { d.open(); }
  };
})();
